/* ───────────── Platform & UI Icons ───────────── */

export const AndroidIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.523 2.273l1.74-1.74a.5.5 0 00-.707-.707l-1.91 1.91A8.46 8.46 0 0012 .5a8.46 8.46 0 00-4.646 1.236L5.444-.174a.5.5 0 00-.707.707l1.74 1.74A8.5 8.5 0 003.5 8.5v1h17v-1a8.5 8.5 0 00-2.977-6.227zM8.5 7a1 1 0 110-2 1 1 0 010 2zm7 0a1 1 0 110-2 1 1 0 010 2zM3.5 11h-1a1 1 0 00-1 1v6a1 1 0 001 1h1v-8zm18 0h-1v8h1a1 1 0 001-1v-6a1 1 0 00-1-1zM5 11v9.5a1.5 1.5 0 001.5 1.5H8v3a1.5 1.5 0 003 0v-3h2v3a1.5 1.5 0 003 0v-3h1.5a1.5 1.5 0 001.5-1.5V11H5z" />
  </svg>
);

export const AppleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

export const ChevronLeftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ChevronRightIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 6 15 12 9 18" />
  </svg>
);